<template>
  <Teleport to="body">
    <Transition name="fade">
      <q-btn
          v-if="debugOptions.showPanelButton && debugAccessEnable"
          round
          color="primary"
          :icon="ICONS.bugReport"
          size="md"
          class="debug-panel-button"
          @click="openDebugPanel"
      >
        <q-tooltip>Открыть панель отладки</q-tooltip>
      </q-btn>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import {useDebugStore} from "@/core/store/debug";
import {useBus} from "@/core/store/bus";
import {storeToRefs} from "pinia";
import {ICONS} from "@/assets/icons";

const debugStore = useDebugStore()
const {bus} = useBus()

const {debugAccessEnable, debugOptions} = storeToRefs(debugStore)

const openDebugPanel = () => {
  bus.emit('router:push', '/dbg-panel')
}
</script>

<style scoped lang="scss">
.debug-panel-button {
  position: fixed;
  right: 16px;
  bottom: 50px;
  z-index: 9000;
  opacity: 0.7;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
